import { RadioGroup } from '@/components/RadioGroup';
import { selectHecsDebt, setHecsDebt } from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { calculateHecsAndNetIncome } from '@/utils/getHecsDebt';

export interface IProps {
    baseId: string;
    showErrors: boolean;
    hecsDebt?: number;
}

export const testId = 'HecsDebt';

export function HecsDebt({ baseId, showErrors }: IProps): JSX.Element {
    // ***** Redux *****
    const currentState = useAppSelector(selectHecsDebt);
    const dispatch = useAppDispatch();
    const income = useAppSelector((state) => state.borrowerReducer.income);
    const isHecsDebtDisplayed = (): boolean => {
        if (!income) return false;

        let annualIncome = 0;
        // Convert paid amount to annual based on frequency
        if (income.paidAmount) {
            switch (income.paidFrequency) {
                case 'WEEKLY':
                    annualIncome =
                        (income.paidAmount + (income.otherIncome || 0)) * 52;
                    break;
                case 'FORTNIGHTLY':
                    annualIncome =
                        (income.paidAmount + (income.otherIncome || 0)) * 26;
                    break;
                case 'MONTHLY':
                    annualIncome =
                        (income.paidAmount + (income.otherIncome || 0)) * 12;
                    break;
                default:
                    annualIncome =
                        income.paidAmount + (income.otherIncome || 0);
            }
        }

        return annualIncome < 65000;
    };
    const amountPaidInBankAccountMonthly =
        useAppSelector((state) => state.borrowerReducer.income.paidAmount) || 0;
    // ***** Event Handlers *****
    function handleChange(value: string | boolean | undefined): void {
        // Convert to boolean and dispatch
        if (value === 'true') {
            const actualHecsRepayment = calculateHecsAndNetIncome(
                amountPaidInBankAccountMonthly,
                income.otherIncome || 0,
                income.paidFrequency
            ).hecsRepayment;
            const ishecsDebtDisplayed = isHecsDebtDisplayed();
            ishecsDebtDisplayed
                ? dispatch(setHecsDebt(actualHecsRepayment))
                : dispatch(setHecsDebt(undefined));
        } else {
            dispatch(setHecsDebt(undefined));
        }
    }
    function calculateValue(currentState: number | undefined): string {
        if (currentState === undefined) {
            return 'false';
        } else {
            return 'true';
        }
    }
    // ***** Render *****
    const options = [
        {
            label: 'Yes',
            value: 'true',
            id: `${baseId}-button-hecsDebt-yes`,
        },
        {
            label: 'No',
            value: 'false',
            id: `${baseId}-button-hecsDebt-no`,
        },
    ];

    return (
        <div data-testid={testId} className='w-full'>
            <RadioGroup
                title='Do you have a HECS/HELP debt?'
                showErrors={showErrors}
                onChange={handleChange}
                options={options}
                value={calculateValue(currentState)}
                tooltipContent='HECS/HELP debt - Government student loan'
            />
        </div>
    );
}
